module.exports = __webpack_public_path__ + "static/img/2.f87bd1d6.jpg";